import * as yup from 'yup';

export interface StateChangeFormValues {
  NewFilingState: number | null;
  EffectiveYear: number | null;
  EffectiveAtRetirement: boolean;
  IsApplied: boolean;
}

export interface FormValues {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  IWontMove: boolean;
  StateChanges: StateChangeFormValues[];
}

export const DEFAULT_STATE_CHANGE = {
  NewFilingState: null,
  EffectiveYear: null,
  EffectiveAtRetirement: false,
  IsApplied: false,
};

export const DEFAULT_VALUES: FormValues = {
  WhatIfKey: '1801',
  WhatIfType: 1801,
  WhatIfTypeName: 'ChangeState',
  IWontMove: false,
  StateChanges: [DEFAULT_STATE_CHANGE],
};

const stateChangeSchema = yup.object({
  IsApplied: yup.boolean(),
  NewFilingState: yup
    .number()
    .nullable()
    .when('IsApplied', {
      is: false,
      then: schema => schema.required('Please select a new filing state.'),
    }),
  EffectiveAtRetirement: yup.boolean(),
  EffectiveYear: yup
    .number()
    .nullable()
    .when(['IsApplied', 'EffectiveAtRetirement'], {
      is: (isApplied: boolean, effectiveAtRetirement: boolean) =>
        !isApplied && !effectiveAtRetirement,
      then: schema =>
        schema
          .typeError('Please select an effective year.')
          .required('Please select an effective year.'),
    }),
});

export const FORM_SCHEMA = yup.object({
  IWontMove: yup.boolean(),
  StateChanges: yup.array().when('IWontMove', {
    is: true,
    then: schema =>
      schema.of(
        yup.object({
          IsApplied: yup.boolean(),
          NewFilingState: yup.number().nullable(),
          EffectiveAtRetirement: yup.boolean(),
          EffectiveYear: yup.number().nullable(),
        }),
      ),
    otherwise: schema => schema.of(stateChangeSchema),
  }),
});
